import { createReducer, on } from '@ngrx/store';
import {
  Microcourse,
  MicrocourseResponse,
} from 'src/app/models/microcourse.model';
import * as MicrocourseActions from './microcourse.actions';
import { MicrocourseState } from './microcourse.state';

const initialState: MicrocourseState = {
  userManagementMicrocourses: [],
  isGettingUserManagementMicrocourse: false,
  getUserManagementMicrocourseErrorMessage: '',

  microcourseResponse: <MicrocourseResponse>{},
  isLoadingResponse: false,
  loadResponseErrorMessage: '',

  microcourse: <Microcourse>{},
  isGetting: false,
  getErrorMessage: '',

  isCreating: false,
  isCreateSuccess: false,
  createErrorMessage: '',

  isUpdating: false,
  isUpdateSuccess: false,
  updateErrorMessage: '',

  isDeleting: false,
  isDeleteSuccess: false,
  deleteErrorMessage: '',

  isPublishing: false,
  isPublishSuccess: false,
  publishErrorMessage: '',

  isSearching: false,
  searchMicrocourseResult: [],
  searchErrorMessage: '',

  isGettingEnrolled: false,
  enrolledMicrocourses: [],
  getEnrolledErrorMessage: '',

  isGettingInfo: false,
  microcourseInfo: <Microcourse>{},
  getInfoErrorMessage: '',

  isGettingCourseOfSkillsetInfo: false,
  courseOfSkillsetInfoList: [],
  getCourseOfSkillsetInfoErrorMessage: '',
};

export const microcourseReducer = createReducer(
  initialState,

  on(MicrocourseActions.clearStates, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      userManagementMicrocourses: [],
      isGettingUserManagementMicrocourse: false,
      getUserManagementMicrocourseErrorMessage: '',

      microcourseResponse: <MicrocourseResponse>{},
      isLoadingResponse: false,
      loadResponseErrorMessage: '',

      microcourse: <Microcourse>{},
      isGetting: false,
      getErrorMessage: '',

      isCreating: false,
      isCreateSuccess: false,
      createErrorMessage: '',

      isUpdating: false,
      isUpdateSuccess: false,
      updateErrorMessage: '',

      isDeleting: false,
      isDeleteSuccess: false,
      deleteErrorMessage: '',

      isPublishing: false,
      isPublishSuccess: false,
      publishErrorMessage: '',

      isSearching: false,
      searchMicrocourseResult: [],
      searchErrorMessage: '',

      isGettingEnrolled: false,
      enrolledMicrocourses: [],
      getEnrolledErrorMessage: '',

      isGettingInfo: false,
      microcourseInfo: <Microcourse>{},
      getInfoErrorMessage: '',
    };
  }),
  on(MicrocourseActions.clearMessages, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingUserManagementMicrocourse: false,
      getUserManagementMicrocourseErrorMessage: '',

      isLoadingResponse: false,
      loadResponseErrorMessage: '',

      isGetting: false,
      getErrorMessage: '',

      isCreating: false,
      isCreateSuccess: false,
      createErrorMessage: '',

      isUpdating: false,
      isUpdateSuccess: false,
      updateErrorMessage: '',

      isDeleting: false,
      isDeleteSuccess: false,
      deleteErrorMessage: '',

      isPublishing: false,
      isPublishSuccess: false,
      publishErrorMessage: '',

      isSearching: false,
      searchErrorMessage: '',

      isGettingEnrolled: false,
      getEnrolledErrorMessage: '',

      isGettingInfo: false,
      getInfoErrorMessage: '',
    };
  }),

  //dynamic for all
  on(MicrocourseActions.getResponse, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isLoadingResponse: true,
      microcourseResponse: <MicrocourseResponse>{},
      loadResponseErrorMessage: '',
    };
  }),
  on(MicrocourseActions.getResponseSuccess, (state, { type, microcourses }) => {
    console.log(type);
    return <MicrocourseState>{
      ...state,
      isLoadingResponse: false,
      microcourseResponse: microcourses,
    };
  }),
  on(MicrocourseActions.getResponseFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isLoadingResponse: false,
      loadResponseErrorMessage: action.errorMessage,
    };
  }),

  on(MicrocourseActions.getById, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGetting: true,
      getErrorMessage: '',
      microcourse: <Microcourse>{},
    };
  }),
  on(MicrocourseActions.getByIdSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGetting: false,
      microcourse: action.microcourse,
    };
  }),
  on(MicrocourseActions.getByIdFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGetting: false,
      getErrorMessage: action.errorMessage,
    };
  }),

  on(MicrocourseActions.getInfo, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingInfo: true,
      getInfoErrorMessage: '',
      microcourseInfo: <Microcourse>{},
    };
  }),
  on(MicrocourseActions.getInfoSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingInfo: false,
      microcourseInfo: action.microcourse,
    };
  }),
  on(MicrocourseActions.getInfoFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingInfo: false,
      getInfoErrorMessage: action.errorMessage,
    };
  }),
  on(MicrocourseActions.clearMicrocourseInfoStates, (state, action) => {
    return <MicrocourseState>{
      ...state,
      isGettingInfo: false,
      getInfoErrorMessage: '',
      microcourseInfo: <Microcourse>{},
    };
  }),

  //for user
  on(MicrocourseActions.getEnrolledById, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingEnrolled: true,
      getEnrolledErrorMessage: '',
    };
  }),
  on(MicrocourseActions.getEnrolledByIdSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingEnrolled: false,
      enrolledMicrocourses: [...state.enrolledMicrocourses, action.microcourse],
    };
  }),
  on(MicrocourseActions.getEnrolledByIdFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingEnrolled: false,
      getEnrolledErrorMessage: action.errorMessage,
    };
  }),
  on(MicrocourseActions.clearEnrolledCourse, (state, action) => {
    return <MicrocourseState>{
      ...state,
      enrolledMicrocourses: [],
    };
  }),

  //admin - creator
  on(MicrocourseActions.getByUserPayload, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingUserManagementMicrocourse: true,
      getUserManagementMicrocourseErrorMessage: '',
    };
  }),
  on(MicrocourseActions.getByUserPayloadSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingUserManagementMicrocourse: false,
      userManagementMicrocourses: [
        ...state.userManagementMicrocourses,
        action.microcourse,
      ],
    };
  }),
  on(MicrocourseActions.getByUserPayloadFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingUserManagementMicrocourse: false,
      getUserManagementMicrocourseErrorMessage: action.errorMessage,
    };
  }),
  on(MicrocourseActions.GetPagination, (state) => {
    return {
      ...state,
      userManagementMicrocourses: [],
    };
  }),

  on(MicrocourseActions.update, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isUpdating: true,
      isUpdateSuccess: false,
      updateErrorMessage: '',
    };
  }),
  on(MicrocourseActions.updateSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isUpdating: false,
      isUpdateSuccess: true,
    };
  }),
  on(MicrocourseActions.updateFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isUpdating: false,
      updateErrorMessage: action.errorMessage,
    };
  }),

  on(MicrocourseActions.deleteById, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isDeleting: true,
      isDeleteSuccess: false,
      deleteErrorMessage: '',
    };
  }),
  on(MicrocourseActions.deleteByIdSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      userManagementMicrocourses: [],
      isDeleting: false,
      isDeleteSuccess: true,
    };
  }),
  on(MicrocourseActions.deleteByIdFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isDeleting: false,
      deleteErrorMessage: action.errorMessage,
    };
  }),

  on(MicrocourseActions.create, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isCreating: true,
      isCreateSuccess: false,
      createErrorMessage: '',
    };
  }),
  on(MicrocourseActions.createSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isCreating: false,
      isCreateSuccess: true,
    };
  }),
  on(MicrocourseActions.createFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isCreating: false,
      createErrorMessage: action.errorMessage,
    };
  }),

  // Publish
  on(MicrocourseActions.publish, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isPublishing: true,
      isPublishSuccess: false,
      publishErrorMessage: '',
    };
  }),
  on(MicrocourseActions.publishSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isPublishing: false,
      isPublishSuccess: true,
    };
  }),
  on(MicrocourseActions.publishFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isPublishing: false,
      publishErrorMessage: action.errorMessage,
    };
  }),

  //search
  on(MicrocourseActions.search, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      searchMicrocourseResult: [],
      isSearching: true,
      searchErrorMessage: '',
    };
  }),
  on(MicrocourseActions.searchSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isSearching: false,
      searchMicrocourseResult: action.microcourses,
    };
  }),
  on(MicrocourseActions.searchFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isSearching: false,
      searchErrorMessage: action.errorMessage,
    };
  }),
  on(MicrocourseActions.clearMicrocourseSearchStates, (state, action) => {
    return <MicrocourseState>{
      ...state,
      isSearching: false,
      searchMicrocourseResult: [],
      searchErrorMessage: '',
    };
  }),
  on(MicrocourseActions.getCourseOfSkillsetInfo, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingCourseOfSkillsetInfo: true,
      getCourseOfSkillsetInfoErrorMessage: '',
    };
  }),
  on(MicrocourseActions.getCourseOfSkillsetInfoSuccess, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingCourseOfSkillsetInfo: false,
      courseOfSkillsetInfoList: [
        ...state.courseOfSkillsetInfoList,
        action.microcourse,
      ],
    };
  }),
  on(MicrocourseActions.getCourseOfSkillsetInfoFailure, (state, action) => {
    console.log(action.type);
    return <MicrocourseState>{
      ...state,
      isGettingCourseOfSkillsetInfo: false,
      getCourseOfSkillsetInfoErrorMessage: action.errorMessage,
    };
  }),
  on(MicrocourseActions.clearMicrocourseOfSkillsetStates, (state, action) => {
    return <MicrocourseState>{
      ...state,
      isGettingCourseOfSkillsetInfo: false,
      getCourseOfSkillsetInfoErrorMessage: '',
      courseOfSkillsetInfoList: [],
    };
  })
);
